const _CSVToArray = (strData, strDelimiter = ',') => {
    // Chia các dòng dựa trên dấu xuống dòng hoặc carriage return
    const rows = strData.split(/\r?\n/);
    const arrData = [];

    // Lặp qua từng dòng
    rows.forEach(row => {
        let arrRow = [];
        let startIndex = 0;
        let inQuotes = false;
        let inJSON = false;

        for (let i = 0; i < row.length; i++) {
            const char = row[i];

            if (char === '"' && !inJSON) {
                inQuotes = !inQuotes; // Đảo ngược trạng thái trong dấu ngoặc kép
            }

            if (char === '{' && !inQuotes) {
                inJSON = true; // Bắt đầu chuỗi JSON
            }

            if (char === '}' && inJSON) {
                inJSON = false; // Kết thúc chuỗi JSON
            }

            if (char === strDelimiter && !inQuotes && !inJSON) {
                arrRow.push(row.substring(startIndex, i).trim());
                startIndex = i + 1;
            }
        }

        // Thêm giá trị cuối cùng trong dòng
        arrRow.push(row.substring(startIndex).trim());
        arrData.push(arrRow);
    });

    return (arrData);
};

const CSVParser = (input, delimiterType) => {
    const dataArray = _CSVToArray(input, delimiterType || '\t');
    return dataArray;
};

export default CSVParser;